import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import { AddToProjectModel, AddToProjectMutationInput } from './model';

export function useCreateAddToProject(
  options?: UseMutationOptions<
    ApiResult<AddToProjectModel>,
    ApiError,
    AddToProjectMutationInput
  >,
): UseMutationResult<
  ApiResult<AddToProjectModel>,
  ApiError,
  AddToProjectMutationInput
> {
  return useMutation<
    ApiResult<AddToProjectModel>,
    ApiError,
    AddToProjectMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `sales/${body.saleId}/add-project`,
      method: 'PUT',
      classType: AddToProjectModel,
      body,
    });
  }, options);
}
